import React from 'react';
import {
    Box,
    InfoOutlined,
    InfoFilled,
    Popover,
    useBreakpoint,
    ConditionalWrapper,
    IconProps,
} from '@landr/maestro';
import { InvertedMode } from '@landr/maestro';

const InfoPopover = ({
    isInverted = true,
    isOutlined = true,
    size,
    children,
}: {
    isInverted?: boolean;
    isOutlined?: boolean;
    size?: IconProps['size'];
    children: React.ReactNode;
}) => {
    const isMobile = useBreakpoint('md');

    return (
        <ConditionalWrapper
            condition={isInverted}
            wrapper={(children: React.ReactNode): React.ReactNode => (
                <InvertedMode>{children}</InvertedMode>
            )}
        >
            <Popover
                triggerEvent={isMobile ? 'click' : 'hover'}
                placement="top"
            >
                <Popover.Trigger>
                    <Box>
                        {isOutlined ? (
                            <InfoOutlined size={size} color="icon.low" />
                        ) : (
                            <InfoFilled size={size} color="icon.low" />
                        )}
                    </Box>
                </Popover.Trigger>
                <Popover.Content
                    maxWidth={{
                        base: undefined,
                        md: '320px',
                    }}
                >
                    {children}
                </Popover.Content>
            </Popover>
        </ConditionalWrapper>
    );
};

export default InfoPopover;
